module.exports = __webpack_public_path__ + "static/media/RP-27.38e3aa21.pdf";